import Model from "../../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../../Styles/InputStyles";

const ChangeOccupancyModal = ({
    setIsChangeOccupancy,
    selectedData,
    changeOccupancyLoading,
    changeOccupancyMutate,
    e
}) => {

    const handleOccupancySubmit = () => {
        changeOccupancyMutate({
            tenantId: selectedData?.data?.id,
            bedId: selectedData?.data?.occupancy?.bedId
        });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsChangeOccupancy}
            title="Confirm Bed Consolidation"
        >
            <WarningText>
                Currently {selectedData?.data?.occupiedBedCount} bed{selectedData?.data?.occupiedBedCount > 1 ? "s" : ""} are occupied. Are you sure you want to shift this tenant to a single bed.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsChangeOccupancy(false)}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleOccupancySubmit}
                    disabled={changeOccupancyLoading}
                >
                    {changeOccupancyLoading ? "Submitting..." : "Submit"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default ChangeOccupancyModal;
